export default __webpack_public_path__ + "static/media/A0007.e4d2c5b1.png";